import Service from '../../services'
import Swal from "sweetalert2";

// initial state
const state = {
  activeDisplay: '',
  statistics: [],
  statisticTotal: {},
  statisticForm: {
    title_th: '',
    title_en: '',
    description_th: '',
    description_en: '',
    caption_th: '',
    caption_en: '',
    name: '',
    topic_id: null,
    graph_type_id: null,
    tags: [],
    url: '',
    is_display_overview: 0,
    is_display_industry: 0,
    industries: [],
    is_display_index: 0,
    ordering_overview: '',
    ordering_industry: '',
    ordering_index: '',
    link_data: 1,
    link_data_url: '',
    reference_text_th: '',
    reference_text_en: '',
    is_show_data_all_year: 0,
    is_hide_detail_table: 0,
  }
}

// getters
const getters = {}

// actions
const actions = {
  async populateStatistics({ commit }, data) {
    const statistics = await Service.statistics.getStatistics(data)
    commit('setStatistics', statistics.data)
    commit('setStatisticTotal', statistics.total)
    return statistics
  },

  async populateStatisticForm({ commit }, id) {
    const statistic = await Service.statistics.getStatisticById(id)
    commit('setStatisticForm', {
      ...statistic,
      tags: statistic.tag_options.map(tag => tag.id),
      industries: statistic.industry_options.map(industry => industry.id),
    })
    return statistic
  },

  clearStatisticForm({ commit }) {
    commit('setStatisticForm', {
      title_th: '',
      title_en: '',
      description_th: '',
      description_en: '',
      caption_th: '',
      caption_en: '',
      name: '',
      topic_id: null,
      graph_type_id: null,
      tags: [],
      url: '',
      is_display_overview: 0,
      is_display_industry: 0,
      industries: [],
      is_display_index: 0,
      ordering_overview: '',
      ordering_industry: '',
      ordering_index: '',
      link_data: 1,
      link_data_url: '',
      reference_text_th: '',
      reference_text_en: '',
      is_show_data_all_year: 0,
      is_hide_detail_table: 0,
    })
  },

  saveStatisticForm({ state }, id) {
    if (id) {
      return Service.statistics.updateStatistic(id, {
        ...state.statisticForm,
        tags: state.statisticForm.tags.toString(),
        industries: state.statisticForm.industries.toString()
      }).then(res => {
        // console.log(res)
      })
    }
    return Service.statistics.createStatistic({
      ...state.statisticForm,
      tags: state.statisticForm.tags.toString(),
      industries: state.statisticForm.industries.toString()
    })
  },

  onDeleteStatistic({ commit }, id) {
    return Service.statistics.deleteStatistic(id).then(() => {
      Swal.fire({
        icon: 'success',
        title:'สำเร็จ!',
        text: 'ลบข้อมูลสำเร็จ',
      })
      // alert('ลบข้อมูลสำเร็จ');
    })
  }

}

// mutations
const mutations = {
  setStatistics(state, data) {
    state.statistics = data
  },
  setStatisticTotal(state, total) {
    state.statisticTotal = total
  },
  setStatisticForm(state, form) {
    state.statisticForm = form
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
